import React, { useEffect, useState } from 'react';
import '../Professionalism.css'; 

const Professionalism = () => {
  const [currentTextIndex, setCurrentTextIndex] = useState(0);
  const texts = [
    { title: "Professionnalisme", subtitle: "Les voiries franciliennes", description: "Les voiries franciliennes possèdent des compétences techniques solides, que ce soit en matière de conception, de construction, de rénovation ou de réparation. " },
    { title: "Qualité", subtitle: "Soucieux de l'environnement", description: "Avec les voiries franciliennes, nous sommes soucieux de l'environnement et nous nous efforçons de minimiser notre impact environnemental." },
    { title: "Communication", subtitle: "Collaboration avec les clients", description: "Nous travaillons en étroite collaboration avec nos clients pour garantir leur satisfaction." },
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTextIndex(prevIndex => (prevIndex + 1) % texts.length);
    }, 3000); // Change le texte toutes les 3 secondes

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="professionalism-section">
      <h3 className={`slide-in`}>{texts[currentTextIndex].title}</h3>
      <hr className="separator-line slide-in" />
      <h4 className={`professionalism-subtitle slide-in`}>
        {texts[currentTextIndex].subtitle}
      </h4>
      <p className="professionalism-description slide-in">
        {texts[currentTextIndex].description}
      </p>
      <button className="arrow-button">&#8594;</button> {/* Flèche à droite */}
    </div>
  );
};

export default Professionalism;
